export const seriesList = [
  {
    id: "s-01",
    title: "旧城迷雾",
    category: "series",
    year: "2024",
    region: "中国大陆",
    director: "郭长明",
    cast: "严宽、宋佳宁、陆昭",
    duration: "全 12 集 · 每集 45 分钟",
    rating: 9.0,
    views: 521000,
    updatedAt: "2024-11-10",
    tags: ["悬疑", "年代", "群像"],
    summary: "九十年代的老工业城里，三起相隔十年的失踪案被同一个人默默记在本子上。",
    description:
      "钢厂关停的那年冬天，档案室管理员在整理旧卷宗时发现三份笔迹相同的报案记录。她开始独自走访那些已经搬空的家属楼，把零散的证词拼在一起。剧集以双线叙事穿梭于 1994 与 2004，用潮湿的雨夜与昏黄的楼道灯，还原一座城市被遗忘的角落。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20series%20poster%20artwork%20of%20a%20foggy%20old%20industrial%20apartment%20block%20with%20dim%20stairwell%20lights%2C%20rain%20slick%20concrete%2C%20cold%20amber%20and%20grey%20tones%2C%20grainy%20film%20texture%2C%20no%20text&width=600&height=900&seq=cov-old-city-fog&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20shot%20of%20a%20foggy%20abandoned%20industrial%20district%20at%20dusk%20with%20dim%20street%20lamps%20and%20distant%20factory%20chimneys%2C%20heavy%20mist%2C%20muted%20amber%20grey%20palette%2C%20grainy%20film%20still%2C%20no%20text&width=1600&height=900&seq=bg-old-city-fog&orientation=landscape",
  },
  {
    id: "s-02",
    title: "河岸人家",
    category: "series",
    year: "2023",
    region: "中国大陆",
    director: "许望",
    cast: "刘佩、王建国、孙晓岚",
    duration: "全 24 集 · 每集 42 分钟",
    rating: 8.5,
    views: 342000,
    updatedAt: "2024-09-28",
    tags: ["家庭", "年代", "生活"],
    summary: "一条河、三代人、四十年，普通中国家庭的日常史诗。",
    description:
      "从八十年代的摆渡船到今天的跨河大桥，河岸边的老周家经历了搬迁、下岗、外出打工与返乡创业。剧集不回避琐碎与争吵，也把年夜饭、修屋顶、送孩子上学这些日常拍得郑重其事。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20series%20poster%20artwork%20of%20a%20small%20riverside%20house%20with%20warm%20windows%20at%20dusk%20and%20a%20wooden%20ferry%20boat%20moored%20nearby%2C%20soft%20golden%20light%2C%20nostalgic%20film%20grain%2C%20warm%20neutral%20palette%2C%20no%20text&width=600&height=900&seq=cov-riverside-family&orientation=portrait",
  },
  {
    id: "s-03",
    title: "三十七天",
    category: "series",
    year: "2024",
    region: "韩国",
    director: "郑河允",
    cast: "徐智厚、文彩英",
    duration: "全 8 集 · 每集 55 分钟",
    rating: 8.7,
    views: 289000,
    updatedAt: "2024-10-18",
    tags: ["惊悚", "悬疑", "犯罪"],
    summary: "一名记者被困在循环的三十七天里，每次醒来，案件都多一名受害者。",
    description:
      "调查记者在追查一起连环案件时遭遇车祸，醒来后发现自己不断回到同一天。她开始用每一天记录不同的线索，也逐渐发现身边的人都在隐瞒同一件事。八集的容量让节奏紧凑到几乎没有喘息的空间。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20series%20poster%20artwork%20of%20a%20broken%20wall%20clock%20in%20a%20dim%20room%20with%20amber%20light%20leaking%20through%20blinds%2C%20suspenseful%20atmosphere%2C%20grainy%20dark%20film%20texture%2C%20muted%20warm%20tones%2C%20no%20text&width=600&height=900&seq=cov-thirty-seven-days&orientation=portrait",
  },
  {
    id: "s-04",
    title: "城南往事",
    category: "series",
    year: "2022",
    region: "中国香港",
    director: "何家树",
    cast: "陈光荣、叶芷、麦子豪",
    duration: "全 30 集 · 每集 43 分钟",
    rating: 8.2,
    views: 174000,
    updatedAt: "2024-08-06",
    tags: ["年代", "剧情", "群像"],
    summary: "九十年代的城南街区，一间茶餐厅见证了无数人的来去。",
    description:
      "茶餐厅的老板娘记性极好，记得每位熟客的口味，也记得他们离开的日子。三十集的故事围绕这条街展开，从舞厅到录像带铺，从码头到天台。每一集都是一张街坊的面孔。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20series%20poster%20artwork%20of%20a%20retro%20hong%20kong%20style%20cafe%20facade%20with%20warm%20yellow%20signage%20glow%20at%20night%2C%20rainy%20street%20reflections%2C%20grainy%20film%20texture%2C%20nostalgic%20palette%2C%20no%20text&width=600&height=900&seq=cov-south-city-past&orientation=portrait",
  },
  {
    id: "s-05",
    title: "边界玩家",
    category: "series",
    year: "2024",
    region: "欧美",
    director: "Daniel Frost",
    cast: "Eva Marsh、Ryan Cole",
    duration: "全 10 集 · 每集 50 分钟",
    rating: 8.4,
    views: 233000,
    updatedAt: "2024-11-04",
    tags: ["犯罪", "剧情", "悬疑"],
    summary: "一个专门替人处理麻烦的中介，在最简单的一单生意上翻了车。",
    description:
      "边境小城的中间人靠帮人解决问题谋生，收费不低，规矩只有一条：不问原因。直到一位老客户带来一个装着手写信的牛皮纸袋，他的规矩第一次被打破。剧集用冷静的镜头与密集的对白，刻画灰色地带的生存逻辑。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20series%20poster%20artwork%20of%20a%20dusty%20border%20road%20with%20a%20lone%20car%20and%20headlights%20cutting%20through%20night%20fog%2C%20amber%20and%20deep%20brown%20tones%2C%20grainy%20film%20still%2C%20tense%20mood%2C%20no%20text&width=600&height=900&seq=cov-border-players&orientation=portrait",
  },
  {
    id: "s-06",
    title: "灯火管理局",
    category: "series",
    year: "2023",
    region: "日本",
    director: "小林澄人",
    cast: "高桥悠、森下有纪",
    duration: "全 12 集 · 每集 40 分钟",
    rating: 8.6,
    views: 210000,
    updatedAt: "2024-07-22",
    tags: ["奇幻", "治愈", "都市"],
    summary: "一个负责管理城市路灯的神秘部门，专门处理那些不肯熄灭的灯。",
    description:
      "新入职的职员被分配到城市灯火管理局，工作内容是巡查那些因为各种原因无法熄灭的路灯。每一盏灯背后都有一个未完成的心愿。剧集以温柔的方式讲述告别，单元故事结构却有一条贯穿始终的暗线。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20series%20poster%20artwork%20of%20a%20row%20of%20old%20street%20lamps%20glowing%20warm%20orange%20along%20a%20quiet%20night%20alley%20with%20soft%20rain%2C%20dreamy%20bokeh%2C%20grainy%20film%20texture%2C%20warm%20palette%2C%20no%20text&width=600&height=900&seq=cov-lamp-bureau&orientation=portrait",
  },
  {
    id: "s-07",
    title: "漫长的黎明",
    category: "series",
    year: "2021",
    region: "欧美",
    director: "Alice Warren",
    cast: "Henry Vale、Clara Dunn",
    duration: "全 6 集 · 每集 60 分钟",
    rating: 8.8,
    views: 156000,
    updatedAt: "2024-06-02",
    tags: ["历史", "剧情", "战争"],
    summary: "一座小城在战后的第一个冬天，如何一点点重新学会正常生活。",
    description:
      "战争结束后的第一个冬天，物资短缺、房屋倒塌、人心未定。市政厅的女书记官负责重建档案，她发现许多人的身份记录已经彻底消失。六集的篇幅克制而厚重，把重建的日常拍成了另一种战场。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20series%20poster%20artwork%20of%20a%20bombed%20european%20town%20square%20at%20cold%20dawn%20with%20pale%20amber%20sunlight%20through%20broken%20arches%2C%20winter%20haze%2C%20grainy%20film%20texture%2C%20muted%20tones%2C%20no%20text&width=600&height=900&seq=cov-long-dawn&orientation=portrait",
  },
  {
    id: "s-08",
    title: "小镇食堂",
    category: "series",
    year: "2024",
    region: "中国大陆",
    director: "钟和平",
    cast: "赵有田、马小艺",
    duration: "全 16 集 · 每集 38 分钟",
    rating: 8.1,
    views: 268000,
    updatedAt: "2024-10-30",
    tags: ["生活", "美食", "治愈"],
    summary: "镇上唯一的食堂，每天只做一件事：让每个进来的人吃上一口热的。",
    description:
      "小镇食堂的老板不爱说话，菜单写在一块掉漆的黑板上。来吃饭的有留守老人、跑长途的司机、刚失恋的年轻人。十六集，十六顿饭，把一个小镇的人情味慢慢炖开。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20series%20poster%20artwork%20of%20a%20cozy%20small%20town%20canteen%20interior%20with%20chalkboard%20menu%2C%20steaming%20dishes%20and%20warm%20pendant%20lights%2C%20grainy%20film%20texture%2C%20warm%20amber%20palette%2C%20no%20text&width=600&height=900&seq=cov-town-canteen&orientation=portrait",
  },
];